import { SuburbanAreaContainer } from '../../containers/advancedFilters/SuburbanAreaContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanArea: IFilter = {
  component: SuburbanAreaContainer,
};
